import { Component, OnInit, OnDestroy, Input, Output } from '@angular/core';
import { NzInputDirective } from 'ng-zorro-antd/input';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { Subscription, BehaviorSubject, Observable } from 'rxjs';
import { debounceTime, map, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import {TaskService} from '../../services/task.service';
@Component({
  selector: 'nf-board-member',
  templateUrl: './board-member.component.html',
  styleUrls: ['./board-member.component.css'],
  providers: [TaskService]
})
export class BoardMemberComponent implements OnInit, OnDestroy {
  dataSubscription: Subscription = null;
  boardData: any = {}; // 面板数据
  boardId: string; // 面板ID
  inviteMailInputValue: string; // 受邀人邮箱地址
  isInviteState = false; // 是否邀请状态
  inviteButtonState = true; // 邀请按钮可点击状态
  memberList: Array<any> = []; // 待选成员列表
  boardSubscribersData: Array<any> = []; // 已选成员列表
  searchChange$ = new BehaviorSubject('');
  isLoading = false;
  randomUserUrl: string;
  selectedMemberValue: string;
  columnData: any;
  total: number;
  pageIndex = 1;
  pageSize = 10;
  searchKey;
  getBoardUserList: Observable<any>;
  loadMoreData = true;
  isOwner = false;
  firstLoading = true;
  @Input('nfData') set changeData(data: any) {
    if (data) {
      this.boardData = data;
      this.boardId = data.id;
      if (data.boardData && data.boardData.currentUser && data.boardData.currentUser.permissions) {
        this.isOwner = data.boardData.currentUser.permissions.includes('owner');
      }
    }
  }
  @Input('nfBoardId') set changeId(data: any) {
    if (data) {
      this.boardId = data;
    }
  }
  @Input('nfColumnData') set changeColumn(data: any) {
    if (data) {
      this.columnData = data;
    }
  }
  constructor(
    private taskService: TaskService,
    private message: NzMessageService,
    private http: HttpClient
  ) { }

  ngOnInit() {
    // this.getBoardUserData();
    this.loadMore();
    this.getBoardSubscribersData();
  }
  ngOnDestroy() {
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
  }
  // 下拉加载更多
  loadMore(): void {
    if (this.loadMoreData) {
      this.randomUserUrl = this.taskService.getBoardUser(this.boardId);
      const param = {
        size: this.pageSize.toString(),
        page: this.pageIndex.toString()
      };
      this.getBoardUserList = this.http
        .get(`${this.randomUserUrl}`, {params: param})
        .pipe(map((res: any) => res))
        .pipe(
          map((list: any) => {
            return list;
          })
        );
      this.isLoading = true;
      this.getBoardUserList.subscribe(data => {
        this.isLoading = false;
        if (data) {
          const newData = data.users && data.users.data ? data.users.data : [];
          this.memberList = [...this.memberList, ...newData];
          if (this.pageIndex === data.users.page.totalPages) {
            this.loadMoreData = false;
            return;
          }
          this.pageIndex = data.users.page.number + 1;
        }
      });
    }
  }
  // 模糊搜索
  onMemberSearch(value: string): void {
    if (this.firstLoading) {
      this.firstLoading = false;
      return;
    }
    this.isLoading = true;
    this.pageIndex = 1;
    const param = {
      size: this.pageSize.toString(),
      page: this.pageIndex.toString(),
      searchKey: value
    };
    this.taskService.getBoardUer(this.boardData.id, param).subscribe((res: any) => {
      if (res) {
        this.memberList = res.users ? res.users.data : [];
        this.loadMoreData = this.pageIndex !== res.users.page.totalPages;
        this.isLoading = false;
      }
    });
    // this.isLoading = true;
    // this.searchChange$.next(value);
    // this.getBoardUserData(value);
  }
  // 支持模糊搜索获取待选成员数据
  getBoardUserData(value) {
    this.randomUserUrl = this.taskService.getBoardUser(this.boardId);
    this.pageIndex = 1;
    const param = {
      size: '999',
      page: this.pageIndex.toString(),
      searchKey: value
    };
    const getRandomNameList = (searchKey: string) =>
      this.http
        .get(`${this.randomUserUrl}`, {params: param})
        .pipe(map((res: any) => res.users ? res.users.data : []))
        .pipe(
          map((list: any) => {
            return list;
          })
        );
    const optionList$: Observable<string[]> = this.searchChange$
      .asObservable()
      .pipe(debounceTime(100))
      .pipe(switchMap(getRandomNameList));
    optionList$.subscribe(data => {
      this.memberList = data;
      this.isLoading = false;
    });
  }
  // 获取面板订阅人列表
  getBoardSubscribersData() {
    const param = {
      // 'page': this.pageIndex,
      // 'size': this.pageSize
    };
    if (this.columnData) {
      // 列入口设置成员
      this.dataSubscription = this.taskService.getColumnUsers(this.boardId, this.columnData.id, param).subscribe((res: any) => {
        this.total = res ? res.length : 0;
        this.boardSubscribersData = res ? res : [];
      });
    } else {
      // 面板入口设置成员
      param['size'] = 500;
      this.dataSubscription = this.taskService.getBoardSubscribers(this.boardId, param).subscribe((res: any) => {
        if (res) {
          this.total = res.page.totalElements;
          this.boardSubscribersData = res.data ? res.data : [];
        }
      });
    }
  }
  // 新增面板订阅人
  addBoardSubscriber(subscriberType, memberId) {
    if (this.columnData) {
      // 列入口设置成员
      const param = {
        'userId': memberId
      };
      this.dataSubscription = this.taskService.addPermit(this.boardId, this.columnData.id, param).subscribe((res: any) => {
        if (res) {
          this.boardSubscribersData = res;
          this.message.create('success', '设置成功！');
          this.getBoardSubscribersData();
        }
      });
    } else {
      // 面板入口设置成员
      const param = {
        'subscriberType': subscriberType,
        'userId': memberId
      };
      this.dataSubscription = this.taskService.addBoardSubscriber(this.boardId, param).subscribe((res: any) => {
        if (res) {
          this.boardSubscribersData = res;
          this.message.create('success', '设置成功！');
          this.getBoardSubscribersData();
        }
      });
    }
  }
  // 修改成员权限
  handleBoardMemberAuthority(type, item) {
    if (!this.isOwner) {
      this.message.warning('您不是面板拥有者，请联系板主进行权限修改');
      return;
    }
    item.subscriberType = 'member';
    switch (type) {
      case 'owner':
        item.isOwner === 'false' ? item.isOwner = 'true' : item.isOwner = 'false';
        item.isViewOnly = 'false';
        item.isViewAll = 'false';
        this.handleOwnerCount(item);
        break;
      case 'viewOnly':
        item.isViewOnly === 'false' ? item.isViewOnly = 'true' : item.isViewOnly = 'false';
        item.isOwner = 'false';
        item.isViewAll = 'false';
        this.handleOwnerCount(item);
        break;
      case 'viewAll':
        item.isViewAll === 'false' ? item.isViewAll = 'true' : item.isViewAll = 'false';
        item.isViewOnly = 'false';
        item.isOwner = 'false';
        this.handleOwnerCount(item);
        break;
    }

  }
  // 修改成员权限请求
  editBoardMemberData(subscriberId, param) {
    this.dataSubscription = this.taskService.editBoardSubscriber(this.boardId, subscriberId, param).subscribe((res: any) => {
      this.message.create('success', '设置成功！');
    });
  }
  // 判断是否管理员个数
  handleOwnerCount(item) {
    let count = 0;
    this.boardSubscribersData.forEach((list, index) => {
      if (list.isOwner === 'true') {
        count = count + 1;
      }
    });
    if (count === 0) {
      this.message.create('warning', '至少保留一个管理员！');
      item.isOwner = 'true';
      item.isViewOnly = 'false';
      item.isViewAll = 'false';
    } else {
      this.editBoardMemberData(item.subscriberId, item);
    }
  }
  // 选择成员回调
  selectedMemberChange(event) {
    let status = true;
    this.selectedMemberValue = event;
    if (event) {
      this.boardSubscribersData.forEach((item, index) => {
        if (event === item.id) {
          status = false;
        }
      });
      if (status) {
        this.addBoardSubscriber('member', event);
      }
    }
  }
  // 邀请成员
  inviteMember() {
    this.isInviteState = true;
    setTimeout(() => {
      document.getElementById('memberMail').focus();
    }, 100);
  }
  // 取消邀请
  cancelInvite() {
    this.isInviteState = false;
    this.inviteMailInputValue = null;
    this.inviteButtonState = true;
  }
  // 受邀邮箱状态控制
  inviteMailKeyEvent(event) {
    const reg = new RegExp('^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$');
    if (reg.test(this.inviteMailInputValue)) {
      this.inviteButtonState = false;
    } else {
      this.inviteButtonState = true;
    }
  }
  doInviteMember() {
    this.addBoardSubscriber('member', this.inviteMailInputValue);
    this.cancelInvite();
  }
  // 删除成员
  removeMember(id) {
    if (!this.isOwner) {
      this.message.warning('您不是面板拥有者，请联系板主进行权限修改');
      return;
    }
    let count = 0;
    let state = true;
    this.boardSubscribersData.forEach((item, index) => {
      if (item.isOwner === 'true') {
        count = count + 1;
      }
      if (id === item.subscriberId && item.isOwner === 'true' && count === 1) {
        this.message.create('warning', '至少保留一个管理员！');
        state = false;
      }
    });
    if (this.columnData) {
      const param = {
        'userId': id
      };
      this.dataSubscription = this.taskService.removePermit(this.boardId, this.columnData.id, param).subscribe((res: any) => {
        if (res) {
          this.message.create('success', '删除成功！');
        }
        this.getBoardSubscribersData();
      });
    } else {
      if (state) {
        this.dataSubscription = this.taskService.removeBoardSubscriber(this.boardId, id).subscribe((res: any) => {
          if (res) {
            this.message.create('success', '删除成功！');
          }
          this.getBoardSubscribersData();
        });
      }
    }
  }
}
